import { useLayoutEffect, useState } from 'react';

// hook to measure the height of a collapsible element
const useContentHeight = (ref, isOpened) => {
  const [contentHeight, setContentHeight] = useState(0);

  useLayoutEffect(() => {
    const measuredContentHeight = (ref.current && ref.current.clientHeight) || 0;
    if (contentHeight !== measuredContentHeight) {
      setContentHeight(measuredContentHeight);
    }
  }, [ref, contentHeight, isOpened]);

  return contentHeight;
};

export default useContentHeight;
